import React, { useState } from 'react';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import styles from './ClearForMeIngredients.module.sass';
import ClickableDiv from '../../../../ui_kit/clickable_div/ClickableDiv';
import IngredientTooltip from '../ingredient_tooltip/IngredientTooltip';

const INGREDIENT_API_URL = 'https://clickable-api.clearforme.com/api/app/ingredients/definition/v2';

function ClearForMeIngredients(props) {
  const { ingredients, requestOptions, clientName } = props;
  const isMulticomponent = ingredients.length > 1;
  const [showTooltip, setShowTooltip] = useState(false);
  const [loading, setLoading] = useState(false);
  const [ingredientData, setIngredientData] = useState({});
  const [currentIngredient, setCurrentIngredient] = useState('');

  const closePopup = () => {
    setShowTooltip(false);
  };

  function onIngredientClick(ingredient) {
    const { ingredientName, productIngredientId, cfmIngredientId } = ingredient;
    setCurrentIngredient(ingredientName);
    setLoading(true);
    fetch(`${INGREDIENT_API_URL}?clientname=${clientName}&productIngredientId=${productIngredientId}&cfmIngredientId=${cfmIngredientId}`, requestOptions)
      .then((res) => res.json())
      .then(
        (result) => {
          setLoading(false);
          setIngredientData(result);
        },
        () => {
          setLoading(false);
        },
      );

    setShowTooltip(true);
  }

  return (
    <>
      {ingredients.map((group) => (
        <React.Fragment key={group.component}>
          <div className={styles.group}>
            { isMulticomponent && (
              <div className={styles.ingredient}>
                {group.component}
                :&nbsp;
              </div>
            )}
            { group.ingredientGroup.map((ingredientGroup) => (
              ingredientGroup.ingredients.map((ingredient, index) => (
                <ClickableDiv
                  className={styles.ingredient}
                  onClick={() => onIngredientClick(ingredient)}
                  key={`${ingredient.ingredientName}_${group.component}`}
                >
                  {ingredient.ingredientName}
                  {ingredient.specialty}
                  {ingredientGroup.ingredients.length - 1 !== index && (
                    <>,&nbsp;</>
                  )}
                </ClickableDiv>
              ))
            )) }
          </div>
        </React.Fragment>
      ))}
      <Modal
        isOpen={showTooltip}
        onRequestClose={closePopup}
        overlayClassName={styles.overlay}
        className={styles.content}
      >
        <IngredientTooltip
          ingredient={currentIngredient}
          definition={ingredientData.definition}
          loading={loading}
          closePopup={closePopup}
          error={ingredientData.error || ingredientData.code}
        />
      </Modal>
    </>
  );
}

ClearForMeIngredients.propTypes = {
  ingredients: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  requestOptions: PropTypes.shape({
    method: PropTypes.string.isRequired,
    headers: PropTypes.shape({}),
    dataType: PropTypes.string.isRequired,
  }).isRequired,
  clientName: PropTypes.string.isRequired,
};

export default ClearForMeIngredients;
